<template>
  <a tabindex="0" v-if="!disabled" v-on="$listeners" :class="'style_'+_style+' size_'+_size" :href="href">
    <slot></slot>
  </a>
  <button tabindex="0" v-else disabled v-on="$listeners" :class="'style_'+_style+' size_'+_size">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      required: false,
      default: '#'
    },
    _style: {
      type: String,
      required: false,
      default: 'default'
    },
    _size: {
      type: String,
      required: false,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {},
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
a, button {
  line-height: 1;
  border:0;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  background-color: #333;
  color: #FFF;
  display: inline-block;
  padding: 0.3em 1em;
  text-decoration: none;
  font-weight: 500;
  border-radius: $standardBorderRadius;
  transition: all 0.1s ease-in-out;

  &:disabled{
    background-color: #CCC !important;
    color: #999 !important;
    &:hover{
      background-color: #CCC !important;
      color: #999 !important;
    }
  }

  &.style_default {
    background-color: $brand;
    color: #FFF;

    &:hover {
      background-color: lighten($brand, 5);
      color: #FFF;
    }
  }

  &.style_neutral {
    background-color: #333;
    color: #FFF;

    &:hover {
      background-color: #555;
      color: #FFF;
    }
  }

  &.style_success {
    background-color: $green;
    color: #FFF;

    &:hover {
      background-color: lighten($green, 5);
      color: #FFF;
    }
  }

  &.style_warning {
    background-color: $red;
    color: #FFF;

    &:hover {
      background-color: darken($red, 5);
      color: #FFF;
    }
  }

  &.style_default_naked {
    padding:0;
    background-color: transparent;
    color: $brand;

    &:hover {
      background-color: transparent;
      color: lighten($brand, 10);
    }
  }

  &.style_warning_naked {
    padding:0;
    background-color: transparent;
    color: $red;

    &:hover {
      background-color: transparent;
      color: lighten($red, 10);
    }
  }

  &.style_neutral_naked {
    padding:0;
    background-color: transparent;
    color: #555;

    &:hover {
      background-color: transparent;
      color: #999;
    }
  }

  &.size_default {
    font-size: 1em;
  }

}
</style>
